import { useAsyncDataWithCapture } from '~/composables/useAsyncDataWithCapture'
import { useCurrentLocationAccount } from '~/composables/useCurrentLocationAccount'
import { getOperators, createOperator, updateOperator } from '~/repositories/operatorRepository'

export const useOperator = () => {
  return {
    getOperators,
    createOperator,
    updateOperator,
  }
}

export const useFetchOperators = async () => {
  const { currentLocationAccount } = useCurrentLocationAccount()
  return await useAsyncDataWithCapture(
    async () => {
      if (!currentLocationAccount.value?.location_id) return []
      return await getOperators(currentLocationAccount.value.location_id)
    },
    {
      watch: [currentLocationAccount],
    }
  )
}
